import React from 'react';
import AppReviews from '../settingProfile/AppReviews';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Header from '../components/Header';
import Home from '../pages/Home';
import About from '../pages/About';
import Features from '../pages/Features';
import Pages from '../pages/Pages';
import Pricing from '../pages/Pricing';
import Blog from '../pages/Blog';
import SourceofInformation from '../pages/SourceofInformation';
import SingleBlog from '../pages/SingleBlog';
import TestSeries from '../pages/TestSeries';
import FreeLiveTest from '../pages/FreeLiveTest';
import Contact from '../pages/Contact';
import NeedSupportSection from '../components/NeedSupportSection';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import DynamicBodyClose from '../components/DynamicBodyClose';
import '../style.css';
import '../color.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import PreviousYear from '../pages/PreviousYear';
import Quizzes from '../pages/Quizzes';
import FreeLiveQuiz from '../pages/FreeLiveQuiz';
import QuantitativeAptitude from '../pages/QuantitativeAptitude';
import QuantitativeAptitude2 from '../pages/QuantitativeAptitude2';
import QuestionDetail from '../pages/QuestionDetail';
import Instructions from '../pages/Instructions';
import QuestionPaper from '../pages/QuestionPaper';
import QuizResult from '../pages/QuizResult';
import TermsAndConditions from '../pages/TermsAndConditions';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import PaymentDisclamer from '../pages/PaymentDisclamer';
import RefundPolicy from '../pages/RefundPolicy';
import NotFound from '../pages/NotFound';
import SignIn from '../components/SignIn';
import SignUp from '../components/SignUp';
import SignUpVerification from '../components/SignUpVerification';
import ForgotPwd from '../components/ForgotPwd';
import CheckEmail from '../components/CheckEmail';
import CreateNewPwd from '../components/CreateNewPwd';
import SocialAuthCallback from '../components/SocialAuthCallback';
import { AUTH_ROUTES } from './authRoutes';
import { SignupStates, SignupExamCategories, SignupFavoriteExams } from '../onboarding/SignupSelections';
import { ONBOARDING_ROUTES } from '../onboarding/onboardingRoutes';
import Dashboard from '../dashboard/Dashboard';
import States from '../dashboard/States';
import Exams from '../dashboard/Exams';
import ProtectedRoute from './ProtectedRoute';
import GuestRoute from './GuestRoute';

import HomeDashboard from '../homeDashboard/HomeDashboard';
import DashboardStates from '../homeDashboard/DashboardStates';
import DashboardFavoriteExam from '../homeDashboard/DashboardFavoriteExam';
import Referralearn from '../homeDashboard/referralEarn/Referralearn';
import ReferralLeaderboard from '../homeDashboard/referralEarn/ReferralLeaderboard';
import { REFERRAL_ROUTES, LEGACY_REFERRAL_ROUTES } from '../homeDashboard/referralEarn/referralRoutes';
import { DASHBOARD_ROUTES } from '../homeDashboard/dashboardRoutes';
import QuizzList from '../homeDashboard/quizzes/QuizzList';
import StartQuiz from '../homeDashboard/quizzes/StartQuiz';
import QuizSelection from '../homeDashboard/quizzes/QuizSelection';
import QuizInstruction from '../homeDashboard/quizzes/QuizInstruction';
import QuizDetail from '../homeDashboard/quizzes/QuizDetail';
import AnswerSheets from '../homeDashboard/quizzes/AnswerSheets';
import QuizLeaderboard from '../homeDashboard/quizzes/QuizLeaderboard';
import ResultAnalysis from '../homeDashboard/quizzes/ResultAnalysis';
import TestSeriesQuizList from '../homeDashboard/quizzes/TestSeriesQuizList';
import { QUIZ_ROUTES } from '../homeDashboard/quizzes/quizRoutes';
import StartRapidFire from '../homeDashboard/rapidFire/StartRapidFire';
import RapidFireDetail from '../homeDashboard/rapidFire/RapidFireDetail';
import RapidFireLeaderBoard from '../homeDashboard/rapidFire/RapidFireLeaderBoard';
import RapidFireAnswerSheets from '../homeDashboard/rapidFire/RapidFireAnswerSheets';
import { RAPID_FIRE_ROUTES } from '../homeDashboard/rapidFire/rapidFireRoutes';
import DashboardQuestionBank from "../DashboardQuestionBank";
import Categories from '../homeDashboard(category)/Categories';
import { EXPLORE_ROUTES } from '../homeDashboard/exploreRoutes';
import QuestionBankTopic from '../questionBank/QuestionBankTopic';
import QuestionBankSubTopic from '../questionBank/QuestionBankSubTopic';
import QuestionBankList from '../questionBank/QuestionBankList';
import QuestionBankPractice from '../questionBank/QuestionBankPractice';
import QBankFilter from '../questionBank/QBankFilter';
import { QUESTION_BANK_ROUTES } from '../questionBank/questionBankRoutes';
import Notification from '../settingProfile/Notification';
import ChangePassword from '../settingProfile/ChangePassword';
import AppLanguage from '../settingProfile/AppLanguage';
import ContentLanguage from '../settingProfile/ContentLanguage';
import SettingEditProfile from '../settingProfile/SettingEditProfile';
import { SETTINGS_ROUTES } from '../settingProfile/settingsRoutes';
import GamificationSubjectCategories from '../homeDashboard/gamification/GamificationSubjectCategories';
import StartGamification from '../homeDashboard/gamification/StartGamification';
import GamificationAttempts from '../homeDashboard/gamification/GamificationAttempts';
import SelectBattle from '../homeDashboard/gamification/SelectBattle';
import CoinStore from '../homeDashboard/gamification/Coinstore';
import CoinHistory from '../homeDashboard/gamification/Coinhistory';
import GamificationLeaderBoard from '../homeDashboard/gamification/GamificationLeaderBoard';
import GamificationBattleLeaderBoard from '../homeDashboard/gamification/GamificationBattleLeaderBoard';
import GamificationAnswerSheets from '../homeDashboard/gamification/GamificationAnswerSheets';
import PlayFriends from '../homeDashboard/gamification/PlayFriends';
import GroupOpponentWaiting from '../homeDashboard/gamification/GroupOpponentWaiting';
import SingleOpponentWaiting from '../homeDashboard/gamification/SingleOpponentWaiting';
import GamificationLiveBattle from '../homeDashboard/gamification/GamificationLiveBattle';
import { GAMIFICATION_ROUTES } from '../homeDashboard/gamification/gamificationRoutes';
import GamificationDetail from '../homeDashboard/gamificationDetail/GamificationDetail';
import GamificationBattleResult from '../homeDashboard/gamificationDetail/GamificationBattleResult';
import GamificationScoreBoardPreview from '../homeDashboard/gamificationDetail/GamificationScoreBoard';
import GroupBattleCardPreview from '../homeDashboard/gamificationDetail/GroupBattleCard';
import ExamCoursePlan from '../homeDashboard/courses/ExamCoursesPlan';
import CourseDetailPreview from '../homeDashboard/courses/CourseDetail';
import CourseTabPreview from '../homeDashboard/courses/CourseTab';
import ExamLectureSubjectPreview from '../homeDashboard/courses/ExamLectureSubject';
import ExamQuestionbankSubjectPreview from '../homeDashboard/courses/ExamQuestionbankSubject';
import ExamShortNotesSubjectPreview from '../homeDashboard/courses/ExamShortNotesSubject';
import MasterExamListPreview from '../homeDashboard/courses/MasterExamList';
import ExamResourceList from '../homeDashboard/courses/ExamResourceList';
import ExamSubjects from '../homeDashboard/courses/ExamSubjects';
import { EXAM_COURSE_ROUTES } from '../homeDashboard/courses/examCourseRoutes';
import NotesList from '../homeDashboard/notes/NotesList';
import { CONTENT_ROUTES } from '../homeDashboard/contentRoutes';
import NotesDetailPreview from '../homeDashboard/notes/Notesdetails';
import ArticleListPreview from '../homeDashboard/articles/ArticleList';
import ArticleDetailsPreview from '../homeDashboard/articles/Articledetails';
import PodcastListPreview from '../homeDashboard/podcast/Podcastlists';
import AudioPodcastPreview from '../homeDashboard/podcast/AudioPodcast';
import StartFlashCards from '../homeDashboard/flashcard/StartFlashCardd';
import FlashCardsStudy from '../homeDashboard/flashcard/FlashCard';
import FlashCardsList from '../homeDashboard/flashcard/CardList';
import { FLASH_CARD_ROUTES } from '../homeDashboard/flashcard/flashCardRoutes';
import InfographicsListPreview from '../homeDashboard/infographics/InfographicList';
import InfographicsDetailPreview from '../homeDashboard/infographics/InfoGraphicDetail';
import DailyQuestionsPreview from '../homeDashboard/dailyQuestion/Dailyquestion';
import DailyQuestionDetailPreview from '../homeDashboard/dailyQuestion/DailyquestionDetail';
import DoubtsPreview from '../homeDashboard/doubts/Doubt';
import AskYourDoubtPreview from '../homeDashboard/doubts/AskYourDoubt';
import DoubtCategoryPreview from '../homeDashboard/doubts/DoubtCategory';
import DoubtSubCategoryPreview from '../homeDashboard/doubts/DoubtSubCategories';
import DoubtDetailPreview from '../homeDashboard/doubts/DoubtDetail';
import { DOUBT_ROUTES } from '../homeDashboard/doubts/doubtRoutes';
import LectureListPreview from '../homeDashboard/lecture/LectureList';
import LectureDetailPreview from '../homeDashboard/lecture/LectureDetail';
import { LECTURE_ROUTES } from '../homeDashboard/lecture/lectureRoutes';
import AssessmentAttempt from '../homeDashboard/subscription/AssessmentAttempt';
import Rapidattempt from '../homeDashboard/subscription/Rapidattempt';
import PaymentResult from '../homeDashboard/subscription/PaymentResult';
import ManualTransfer from '../homeDashboard/subscription/ManualTransfer';
import SubScriptions from '../homeDashboard/subscription/SubScriptions';
import { SUBSCRIPTION_ROUTES } from '../homeDashboard/subscription/subscriptionRoutes';
import SubscriptionStaticPreview from '../homeDashboard/subscription/SubscriptionStaticPreview';
import SubjectPlans from '../homeDashboard/subscription/SubjectPlans';
import SubjectPlanDetail from '../homeDashboard/subscription/SubjectPlanDetail';
import AssessmentPlans from '../homeDashboard/subscription/AssessmentPlans';
import AssessmentPlanDetail from '../homeDashboard/subscription/AssessmentPlanDetail';
import ExamPlanList from '../homeDashboard/subscription/ExamPlanList';
import ExamPlanDetail from '../homeDashboard/subscription/ExamPlanDetail';
import SearchCategories from '../homeDashboard/search/SearchCategories';
import { SEARCH_ROUTES } from '../homeDashboard/search/searchRoutes';
import SearchQuestionList from '../homeDashboard/search/SearchQuestionList';
import SearchShortNotes from '../homeDashboard/search/SearchShortNotes';
import SearchTestQuiz from '../homeDashboard/search/SearchTestQuiz';
import SearchNotesDetail from '../homeDashboard/search/SearchNotesDetail';
import SearchArticleDetail from '../homeDashboard/search/SearchArticleDetail';
import SearchTestSeries from '../homeDashboard/search/SearchTestSeries';
import SearchNewsArticle from '../homeDashboard/search/SearchNewsArticle';
import SearchLectureDetail from '../homeDashboard/search/SearchLectureDetail';
import SearchQuestionDetail from '../homeDashboard/search/SearchQuestionDetail';
import SearchResults from '../homeDashboard/search/SearchResults';
import SearchDemoLecture from '../homeDashboard/search/SearchDemoLecture';
import VoiceChat from '../homeDashboard/voiceChat/VoiceChat';
import QuestionPaperList from '../homeDashboard/questionBank/QuestionPaperList';
import { AI_TUTOR_ROUTES } from '../homeDashboard/voiceChat/aiTutorRoutes';
import MyProgressPage from '../homeDashboard/MyProgressPage';

import SubscriptionPaymentPage from '../homeDashboard/subscription/SubscriptionPaymentPage';
const HIDE_LAYOUT_PATHS = new Set([
  AUTH_ROUTES.signIn,
  '/reviews',
  AUTH_ROUTES.signUp,
  AUTH_ROUTES.verification,
  AUTH_ROUTES.forgotPassword,
  AUTH_ROUTES.checkEmail,
  AUTH_ROUTES.newPassword,
  AUTH_ROUTES.socialCallback,
  DASHBOARD_ROUTES.home,
  DASHBOARD_ROUTES.progress,
  DASHBOARD_ROUTES.examCategories,
  DASHBOARD_ROUTES.selectExams,
  DASHBOARD_ROUTES.preview,
  DASHBOARD_ROUTES.states,
  DASHBOARD_ROUTES.favoriteExams,
  ...Object.values(REFERRAL_ROUTES),
  ...Object.values(LEGACY_REFERRAL_ROUTES),
  EXPLORE_ROUTES.subjects,
  SETTINGS_ROUTES.notifications,
  SETTINGS_ROUTES.password,
  SETTINGS_ROUTES.appLanguage,
  SETTINGS_ROUTES.contentLanguage,
  SETTINGS_ROUTES.profile,
  QUESTION_BANK_ROUTES.list,
  EXPLORE_ROUTES.topics,
  EXPLORE_ROUTES.subtopics,
  QUESTION_BANK_ROUTES.practice,
  QUESTION_BANK_ROUTES.filter,
  CONTENT_ROUTES.notes,
  CONTENT_ROUTES.noteDetail,
  CONTENT_ROUTES.articles,
  CONTENT_ROUTES.articleDetail,
  CONTENT_ROUTES.podcasts,
  CONTENT_ROUTES.podcastDetail,
  FLASH_CARD_ROUTES.start,
  FLASH_CARD_ROUTES.study,
  FLASH_CARD_ROUTES.list,
  CONTENT_ROUTES.infographics,
  CONTENT_ROUTES.infographicDetail,
  CONTENT_ROUTES.dailyQuestions,
  CONTENT_ROUTES.dailyQuestionDetail,
  '/doubts',  '/question-paper-list', '/my-progress',
  ...Object.values(AI_TUTOR_ROUTES),
  ...Object.values(SEARCH_ROUTES),
  DOUBT_ROUTES.ask,
  DOUBT_ROUTES.categories,
  DOUBT_ROUTES.subcategories,
  DOUBT_ROUTES.detail,
  LECTURE_ROUTES.list,
  LECTURE_ROUTES.detail,
  EXAM_COURSE_ROUTES.plans,
  EXAM_COURSE_ROUTES.masterExams,
  EXAM_COURSE_ROUTES.detail,
  EXAM_COURSE_ROUTES.tabs,
  EXAM_COURSE_ROUTES.subjects,
  EXAM_COURSE_ROUTES.lectureSubjects,
  EXAM_COURSE_ROUTES.questionBankSubjects,
  EXAM_COURSE_ROUTES.shortNotesSubjects,
  EXPLORE_ROUTES.categories,
  QUIZ_ROUTES.list,
  QUIZ_ROUTES.start,
  QUIZ_ROUTES.selection,
  QUIZ_ROUTES.instruction,
  QUIZ_ROUTES.detail,
  QUIZ_ROUTES.answerSheet,
  QUIZ_ROUTES.leaderboard,
  QUIZ_ROUTES.resultAnalysis,
  QUIZ_ROUTES.testSeriesList,
  RAPID_FIRE_ROUTES.start,
  RAPID_FIRE_ROUTES.detail,
  RAPID_FIRE_ROUTES.leaderboard,
  RAPID_FIRE_ROUTES.answerSheet,
  GAMIFICATION_ROUTES.start,
  GAMIFICATION_ROUTES.subjects,
  GAMIFICATION_ROUTES.attempts,
  GAMIFICATION_ROUTES.selectBattle,
  GAMIFICATION_ROUTES.leaderboard,
  GAMIFICATION_ROUTES.battleLeaderboard,
  GAMIFICATION_ROUTES.answerSheet,
  GAMIFICATION_ROUTES.coinStore,
  GAMIFICATION_ROUTES.coinHistory,
  GAMIFICATION_ROUTES.playFriends,
  GAMIFICATION_ROUTES.groupWaiting,
  GAMIFICATION_ROUTES.singleWaiting,
  GAMIFICATION_ROUTES.liveBattle,
  GAMIFICATION_ROUTES.detail,
  GAMIFICATION_ROUTES.battleResult,
  GAMIFICATION_ROUTES.scoreboard,
  GAMIFICATION_ROUTES.groupBattleCard,
  EXPLORE_ROUTES.exams,
  '/subscriptions',
  SUBSCRIPTION_ROUTES.subjectPlans,
  SUBSCRIPTION_ROUTES.subjectDetail,
  '/subscriptions/preview/exam-plans',
  '/subscriptions/preview/exam-plan-details',
  SUBSCRIPTION_ROUTES.assessmentPlans,
  SUBSCRIPTION_ROUTES.examPlans,
  SUBSCRIPTION_ROUTES.examDetail,
  SUBSCRIPTION_ROUTES.assessmentDetail,
  SUBSCRIPTION_ROUTES.assessmentReattempts,
  SUBSCRIPTION_ROUTES.rapidFireAttempts,
  SUBSCRIPTION_ROUTES.coinStore,
  SUBSCRIPTION_ROUTES.coinHistory,
  SUBSCRIPTION_ROUTES.paymentMethod,
  SUBSCRIPTION_ROUTES.paymentResult,
  SUBSCRIPTION_ROUTES.manualTransfer,
  '/dashboard/exam-cat',
  ONBOARDING_ROUTES.states,
  ONBOARDING_ROUTES.categories,
  ONBOARDING_ROUTES.exams,
]);

function AppRoutes() {
  const location = useLocation();
  const hideSharedLayout = HIDE_LAYOUT_PATHS.has(location.pathname)
    || location.pathname.startsWith(`${SEARCH_ROUTES.categories}/`)
    || location.pathname.startsWith(`${EXAM_COURSE_ROUTES.resources}/`);

  return (
    <>
      {!hideSharedLayout && <Header />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/features" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/source-of-information" element={<SourceofInformation />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/payment-disclaimer" element={<PaymentDisclamer />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/auth">
          <Route path="sign-in" element={<GuestRoute><SignIn /></GuestRoute>} />
          <Route path="sign-up" element={<GuestRoute><SignUp /></GuestRoute>} />
          <Route path="sign-up/verification" element={<GuestRoute><SignUpVerification /></GuestRoute>} />
          <Route path="forgot-password" element={<GuestRoute><ForgotPwd /></GuestRoute>} />
          <Route path="check-email" element={<GuestRoute><CheckEmail /></GuestRoute>} />
          <Route path="new-password" element={<GuestRoute><CreateNewPwd /></GuestRoute>} />
          <Route path="social-callback" element={<SocialAuthCallback />} />
        </Route>
        <Route path="/onboarding">
          <Route path="states" element={<ProtectedRoute><SignupStates /></ProtectedRoute>} />
          <Route path="exam-categories" element={<ProtectedRoute><SignupExamCategories /></ProtectedRoute>} />
          <Route path="favorite-exams" element={<ProtectedRoute><SignupFavoriteExams /></ProtectedRoute>} />
        </Route>
        <Route path="/dashboard">
          <Route index element={<ProtectedRoute><HomeDashboard /></ProtectedRoute>} />
          <Route path="preview" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="states" element={<ProtectedRoute><DashboardStates /></ProtectedRoute>} />
          <Route path="favorite-exams" element={<ProtectedRoute><DashboardFavoriteExam /></ProtectedRoute>} />
          <Route path="exam-categories" element={<ProtectedRoute><SignupExamCategories dashboard /></ProtectedRoute>} />
          <Route path="exam-categories/exams" element={<ProtectedRoute><SignupFavoriteExams dashboard /></ProtectedRoute>} />
          <Route path="exam-cat" element={<Navigate to={DASHBOARD_ROUTES.examCategories} replace />} />
        </Route>
        <Route path={LEGACY_REFERRAL_ROUTES.home} element={<Navigate to={REFERRAL_ROUTES.home} replace />} />
        <Route path={LEGACY_REFERRAL_ROUTES.leaderboard} element={<Navigate to={REFERRAL_ROUTES.leaderboard} replace />} />
        <Route path={REFERRAL_ROUTES.home}>
          <Route index element={<ProtectedRoute><Referralearn /></ProtectedRoute>} />
          <Route path="leaderboard" element={<ProtectedRoute><ReferralLeaderboard /></ProtectedRoute>} />
        </Route>
        <Route path="/explore">
          <Route path="states" element={<ProtectedRoute><States /></ProtectedRoute>} />
          <Route path="exams" element={<ProtectedRoute><Exams /></ProtectedRoute>} />
          <Route path="subjects" element={<ProtectedRoute><DashboardQuestionBank /></ProtectedRoute>} />
          <Route path="categories" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
          <Route path="topics" element={<ProtectedRoute><QuestionBankTopic /></ProtectedRoute>} />
          <Route path="subtopics" element={<ProtectedRoute><QuestionBankSubTopic /></ProtectedRoute>} />
        </Route>
        <Route path="/quizzes">
          <Route index element={<ProtectedRoute><QuizzList /></ProtectedRoute>} />
          <Route path="start" element={<ProtectedRoute><StartQuiz /></ProtectedRoute>} />
          <Route path="selection" element={<ProtectedRoute><QuizSelection /></ProtectedRoute>} />
          <Route path="instruction" element={<ProtectedRoute><QuizInstruction /></ProtectedRoute>} />
          <Route path="detail" element={<ProtectedRoute><QuizDetail /></ProtectedRoute>} />
          <Route path="answer-sheet" element={<ProtectedRoute><AnswerSheets /></ProtectedRoute>} />
          <Route path="leaderboard" element={<ProtectedRoute><QuizLeaderboard /></ProtectedRoute>} />
          <Route path="result-analysis" element={<ProtectedRoute><ResultAnalysis /></ProtectedRoute>} />
          <Route path="test-series" element={<ProtectedRoute><TestSeriesQuizList /></ProtectedRoute>} />
        </Route>
        <Route path="/reviews" element={<ProtectedRoute><AppReviews /></ProtectedRoute>} />
        <Route path="/rapid-fire">
          <Route index element={<ProtectedRoute><StartRapidFire /></ProtectedRoute>} />
          <Route path="detail" element={<ProtectedRoute><RapidFireDetail /></ProtectedRoute>} />
          <Route path="leaderboard" element={<ProtectedRoute><RapidFireLeaderBoard /></ProtectedRoute>} />
          <Route path="answer-sheet" element={<ProtectedRoute><RapidFireAnswerSheets /></ProtectedRoute>} />
        </Route>
        <Route path="/gamification">
          <Route index element={<ProtectedRoute><StartGamification /></ProtectedRoute>} />
          <Route path="subjects" element={<ProtectedRoute><GamificationSubjectCategories /></ProtectedRoute>} />
          <Route path="attempts" element={<ProtectedRoute><GamificationAttempts /></ProtectedRoute>} />
          <Route path="leaderboard" element={<ProtectedRoute><GamificationLeaderBoard /></ProtectedRoute>} />
          <Route path="coin-store" element={<ProtectedRoute><CoinStore /></ProtectedRoute>} />
          <Route path="coin-history" element={<ProtectedRoute><CoinHistory /></ProtectedRoute>} />
          <Route path="battles">
            <Route path="select" element={<ProtectedRoute><SelectBattle /></ProtectedRoute>} />
            <Route path="leaderboard" element={<ProtectedRoute><GamificationBattleLeaderBoard /></ProtectedRoute>} />
            <Route path="answer-sheet" element={<ProtectedRoute><GamificationAnswerSheets /></ProtectedRoute>} />
            <Route path="friends" element={<ProtectedRoute><PlayFriends /></ProtectedRoute>} />
            <Route path="group/waiting" element={<ProtectedRoute><GroupOpponentWaiting /></ProtectedRoute>} />
            <Route path="single/waiting" element={<ProtectedRoute><SingleOpponentWaiting /></ProtectedRoute>} />
            <Route path="live" element={<ProtectedRoute><GamificationLiveBattle /></ProtectedRoute>} />
            <Route path="detail" element={<GamificationDetail />} />
            <Route path="result" element={<ProtectedRoute><GamificationBattleResult /></ProtectedRoute>} />
            <Route path="scoreboard" element={<GamificationScoreBoardPreview />} />
            <Route path="group/card" element={<GroupBattleCardPreview />} />
          </Route>
        </Route>
        <Route path="/exam-courses">
          <Route index element={<ProtectedRoute><ExamCoursePlan /></ProtectedRoute>} />
          <Route path="master-exams" element={<ProtectedRoute><MasterExamListPreview /></ProtectedRoute>} />
          <Route path="detail" element={<ProtectedRoute><CourseDetailPreview /></ProtectedRoute>} />
          <Route path="tabs" element={<ProtectedRoute><CourseTabPreview /></ProtectedRoute>} />
          <Route path="subjects">
            <Route index element={<ProtectedRoute><ExamSubjects /></ProtectedRoute>} />
            <Route path="lectures" element={<ProtectedRoute><ExamLectureSubjectPreview /></ProtectedRoute>} />
            <Route path="question-bank" element={<ProtectedRoute><ExamQuestionbankSubjectPreview /></ProtectedRoute>} />
            <Route path="short-notes" element={<ProtectedRoute><ExamShortNotesSubjectPreview /></ProtectedRoute>} />
          </Route>
          <Route path="resources/:resourceType" element={<ProtectedRoute><ExamResourceList /></ProtectedRoute>} />
        </Route>
        <Route path="/content">
          <Route path="notes">
            <Route index element={<ProtectedRoute><NotesList /></ProtectedRoute>} />
            <Route path="detail" element={<ProtectedRoute><NotesDetailPreview /></ProtectedRoute>} />
          </Route>
          <Route path="articles">
            <Route index element={<ProtectedRoute><ArticleListPreview /></ProtectedRoute>} />
            <Route path="detail" element={<ProtectedRoute><ArticleDetailsPreview /></ProtectedRoute>} />
          </Route>
          <Route path="podcasts">
            <Route index element={<ProtectedRoute><PodcastListPreview /></ProtectedRoute>} />
            <Route path="detail" element={<ProtectedRoute><AudioPodcastPreview /></ProtectedRoute>} />
          </Route>
          <Route path="infographics">
            <Route index element={<ProtectedRoute><InfographicsListPreview /></ProtectedRoute>} />
            <Route path="detail" element={<ProtectedRoute><InfographicsDetailPreview /></ProtectedRoute>} />
          </Route>
          <Route path="daily-questions">
            <Route index element={<ProtectedRoute><DailyQuestionsPreview /></ProtectedRoute>} />
            <Route path="detail" element={<ProtectedRoute><DailyQuestionDetailPreview /></ProtectedRoute>} />
          </Route>
        </Route>
        <Route path="/flash-cards">
          <Route index element={<ProtectedRoute><StartFlashCards /></ProtectedRoute>} />
          <Route path="study" element={<ProtectedRoute><FlashCardsStudy /></ProtectedRoute>} />
          <Route path="list" element={<ProtectedRoute><FlashCardsList /></ProtectedRoute>} />
        </Route>
        <Route path="/doubts">
          <Route index element={<ProtectedRoute><DoubtsPreview /></ProtectedRoute>} />
          <Route path="ask" element={<ProtectedRoute><AskYourDoubtPreview /></ProtectedRoute>} />
          <Route path="categories" element={<ProtectedRoute><DoubtCategoryPreview /></ProtectedRoute>} />
          <Route path="subcategories" element={<ProtectedRoute><DoubtSubCategoryPreview /></ProtectedRoute>} />
          <Route path="detail" element={<ProtectedRoute><DoubtDetailPreview /></ProtectedRoute>} />
        </Route>
        <Route path="/lectures">
          <Route index element={<ProtectedRoute><LectureListPreview /></ProtectedRoute>} />
          <Route path="detail" element={<ProtectedRoute><LectureDetailPreview /></ProtectedRoute>} />
        </Route>
        <Route path="/subscriptions">
          <Route index element={<ProtectedRoute><SubScriptions /></ProtectedRoute>} />
          <Route path="subject-plans" element={<ProtectedRoute><SubjectPlans /></ProtectedRoute>} />
          <Route path="subject-plan-detail" element={<ProtectedRoute><SubjectPlanDetail /></ProtectedRoute>} />
          <Route path="preview/exam-plans" element={<ProtectedRoute><SubscriptionStaticPreview page="exam-plans" /></ProtectedRoute>} />
          <Route path="preview/exam-plan-details" element={<ProtectedRoute><SubscriptionStaticPreview page="exam-plan-details" /></ProtectedRoute>} />
          <Route path="assessment-plans" element={<ProtectedRoute><AssessmentPlans /></ProtectedRoute>} />
          <Route path="exam-plans" element={<ProtectedRoute><ExamPlanList /></ProtectedRoute>} />
          <Route path="exam-plan-detail" element={<ProtectedRoute><ExamPlanDetail /></ProtectedRoute>} />
          <Route path="assessment-plan-detail" element={<ProtectedRoute><AssessmentPlanDetail /></ProtectedRoute>} />
          <Route path="assessment-reattempts" element={<ProtectedRoute><AssessmentAttempt /></ProtectedRoute>} />
          <Route path="rapid-fire-attempts" element={<ProtectedRoute><Rapidattempt /></ProtectedRoute>} />
          <Route path="coin-store" element={<ProtectedRoute><CoinStore /></ProtectedRoute>} />
          <Route path="coin-history" element={<ProtectedRoute><CoinHistory /></ProtectedRoute>} />
          <Route path="payment-method" element={<ProtectedRoute><SubscriptionPaymentPage /></ProtectedRoute>} />
          <Route path="payment-result" element={<ProtectedRoute><PaymentResult /></ProtectedRoute>} />
          <Route path="manual-transfer" element={<ProtectedRoute><ManualTransfer /></ProtectedRoute>} />
        </Route>
        <Route path="/settings">
          <Route path="notifications" element={<ProtectedRoute><Notification /></ProtectedRoute>} />
          <Route path="password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          <Route path="app-language" element={<ProtectedRoute><AppLanguage /></ProtectedRoute>} />
          <Route path="content-language" element={<ProtectedRoute><ContentLanguage /></ProtectedRoute>} />
          <Route path="profile" element={<ProtectedRoute><SettingEditProfile /></ProtectedRoute>} />
        </Route>
        
        <Route path="/question-bank">
          <Route index element={<ProtectedRoute><QuestionBankList /></ProtectedRoute>} />
          <Route path="practice" element={<ProtectedRoute><QuestionBankPractice /></ProtectedRoute>} />
          <Route path="filter" element={<ProtectedRoute><QBankFilter /></ProtectedRoute>} />
        </Route>
        <Route path={SEARCH_ROUTES.categories}>
          <Route index element={<ProtectedRoute><SearchCategories /></ProtectedRoute>} />
          <Route path="questions" element={<ProtectedRoute><SearchQuestionList /></ProtectedRoute>} />
          <Route path="short-notes" element={<ProtectedRoute><SearchShortNotes /></ProtectedRoute>} />
          <Route path="quiz-pyp" element={<ProtectedRoute><SearchTestQuiz /></ProtectedRoute>} />
          <Route path="blogs" element={<ProtectedRoute><SearchNewsArticle /></ProtectedRoute>} />
          <Route path="lectures" element={<ProtectedRoute><SearchResults categoryId={3} /></ProtectedRoute>} />
          <Route path="exams" element={<ProtectedRoute><SearchResults categoryId={7} /></ProtectedRoute>} />
          <Route path="series/quizzes" element={<ProtectedRoute><SearchResults categoryId={1} series /></ProtectedRoute>} />
          <Route path="questions/detail" element={<ProtectedRoute><SearchQuestionDetail /></ProtectedRoute>} />
          <Route path="short-notes/detail" element={<ProtectedRoute><SearchNotesDetail /></ProtectedRoute>} />
          <Route path="blogs/detail" element={<ProtectedRoute><SearchArticleDetail /></ProtectedRoute>} />
          <Route path="lectures/detail" element={<ProtectedRoute><SearchLectureDetail /></ProtectedRoute>} />
          <Route path="lectures/demo" element={<ProtectedRoute><SearchDemoLecture /></ProtectedRoute>} />
          <Route path="test-series" element={<ProtectedRoute><SearchTestSeries /></ProtectedRoute>} />
        </Route>
        <Route path="/ai-tutor">
          <Route path="voice-chat" element={<ProtectedRoute><VoiceChat /></ProtectedRoute>} />
        </Route>
        <Route path="question-paper-list" element={<QuestionPaperList/>} />
        <Route path={DASHBOARD_ROUTES.progress} element={<ProtectedRoute><MyProgressPage /></ProtectedRoute>} />
        <Route path="my-progress" element={<Navigate to={DASHBOARD_ROUTES.progress} replace />} />
        <Route
          path="/blog/:parent_slug?/:child_slug/:blog_slug"
          element={
            <GoogleReCaptchaProvider
              reCaptchaKey="6Lcte2IrAAAAAGDqWdU6oQEpXagat9JMa39nOa6I"
              scriptProps={{
                async: true,
                defer: true,
                appendTo: 'head',
              }}
            >
              <SingleBlog />
            </GoogleReCaptchaProvider>
          }
        />
        <Route
          path="/contact"
          element={
            <GoogleReCaptchaProvider
              reCaptchaKey="6Lcte2IrAAAAAGDqWdU6oQEpXagat9JMa39nOa6I"
              scriptProps={{
                async: true,
                defer: true,
                appendTo: 'head',
              }}
            >
              <Contact />
            </GoogleReCaptchaProvider>
          }
        />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/pages" element={<Pages />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!hideSharedLayout && (
        <>
          <NeedSupportSection />
          <Footer />
        </>
      )}
      <DynamicBodyClose />
    </>
  );
}

function PageRoute() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default PageRoute;






